/**
 * @author gabyong.kim
 * @email gabyong.kim@gloovir.com
 * @create date 2023-10-18 17:15:37
 * @modify date 2023-10-18 17:15:37
 * @desc 프로젝트 관리 화면 정의
 */


import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { requests } from "../../../common/RestAPI";
import { SESSIONSTORAGE } from "../../../value/staticValues";
import { PAGE_URL, PLATFORM_URL } from "../../../value/Url";
import ContentsProps from "../../../interfaceTypes/ContentsProps";
import ProjectMgmt from "./ProjectMgmt";
import {  ProjectData, tableHeaders } from "./ProjectData";
import { generateQueryParam } from "common/util";



interface ProjectMgmtContainerProps extends ContentsProps {
    moveDetailCb: Function;
}


export default function ProjectMgmtContainer(props:ProjectMgmtContainerProps) {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [infoText, setInfoText] = useState('');
    const [infoError, setInfoError] = useState(false);

    const fetchIdRef = useRef(0);
    const [currentPage, setCurrentPage] = useState(0);
    const [pageCount, setPageCount] = useState(0);
    const [totalItemCount, setTotalItemCount] = useState(0);
    const [selectItems, setSelectItems] = useState([]);
    const [tableData, setTableData] = useState<ProjectData[]>([]);
    const [refreshYn, setRefreshYn] = useState(false);

    const headers = useMemo(() => tableHeaders, []);


    useEffect(() => {
        AlertFunction('');
    }, []);

    function AlertFunction(text:string, error=false) {
        setInfoText(text);
        setInfoError(error);
    }


    function clickRow(item) {
        sessionStorage.removeItem(SESSIONSTORAGE.PROJECT_TARGET_ID);
        props.moveDetailCb(item.project_id);
        navigate(`${PAGE_URL.DETAIL_MANAGEMENT}`);
    }


    function clickActionMenu(code) {
        if(code === "PROJECT_SYNC") {
            requests.post(PLATFORM_URL.PROJECT + PLATFORM_URL.SYNC, {})
            .then(async (response) => {
                if (response.status === 200) {
                    setRefreshYn(true);
                    AlertFunction(t("SYNC_COMPLETED_TEXT"));
                }
            })
        }
    }
    function executeLoadProjectList(pageSize, pageIndex, sortByName, sortByDescYn, categoryType, categoryCode, search, showLoading) {
        if(showLoading) {
            setCurrentPage(pageIndex);
            props.setLoading(true);
        }

        requests.get(PLATFORM_URL.PROJECT, generateQueryParam(pageSize, pageIndex, sortByName, sortByDescYn, categoryType, categoryCode, search))
        .then((response) => {
            if (response.status === 200 && response.data && pageIndex === response.data.page-1) {
                setTableData(response.data.items);
                setPageCount(response.data.pages);
                setTotalItemCount(response.data.total);
            }
            if(showLoading) {
                props.setLoading(false);
                setRefreshYn(false);
            }
        })
        .catch((error) => {
            AlertFunction(t("MESSAGE_CANNOT_LOAD_DATA_MESSAGE"), true);
            if(showLoading) {
                props.setLoading(false);
                setRefreshYn(false);
            }
        })
    }


    const fetchData = useCallback(({ pageSize, pageIndex, sortByName, sortByDescYn, categoryType, categoryCode, search, showLoading }) => {
        const fetchId = ++fetchIdRef.current
        if(fetchId === fetchIdRef.current) {
            executeLoadProjectList(pageSize, pageIndex, sortByName, sortByDescYn, categoryType, categoryCode, search, showLoading);
        }
    }, []);


    return (
        <ProjectMgmt
            clickActionMenu={clickActionMenu}
            clickRow={clickRow}
            fetchData={fetchData}
            currentPage={currentPage}
            pageCount={pageCount}
            headers={headers}
            tableData={tableData}
            totalItemCount={totalItemCount}
            refreshYn={refreshYn}
            infoText={infoText}
            infoError={infoError}
        />
    )
}